import COUNTRY_LINK_CODE from '@/Common/vue/components/components/hikProConnectProductUrl.js';
import bury from './bury-point';
import Api from './api';
import useEventBus from '@/natives/libs/hooks/useEventBus';

let countryOrRegionIndex = Number(localStorage.getItem('hik_connect_pro_country'));
const countryOrRegionChange = useEventBus('country-or-region-change');
countryOrRegionChange.on((index) => {
  countryOrRegionIndex = index;
});

let languageIndex = Number(localStorage.getItem('hik_connect_pro_locale'));
const languageChange = useEventBus('language-change');
languageChange.on((index) => {
  languageIndex = index;
});

const PREFIX = {
  DEFAULT: 'hik_connect_pro_'
};

const geteLearningUrl = () => {
  const origin = window.location.origin;
  if (origin === 'https://ius.hik-partner.com') {
    // 北美PE
    return 'https://elearning.hikvision.com/en/';
  }
  if (origin === 'https://isa.hik-partner.com') {
    // 南美PE
    return 'https://elearning.hikvision.com/en/';
  }
  if (origin === 'https://isgp.hik-partner.com') {
    // 新加坡PE
    return 'https://elearning.hikvision.com/en/';
  }
  if (origin === 'https://ieu.hik-partner.com') {
    // 欧洲PE
    return 'https://elearning.hikvision.com/en/';
  }
  if (origin === 'https://www.hik-partner.com') {
    // 欧洲PE
    return 'https://elearning.hikvision.com/en/';
  }
  if (origin === 'https://hik-partnerru.com') {
    // 俄罗斯
    return 'https://elearning.hikvision.com/en/';
  }
  if (origin === 'https://www.hik-partnerru.com') {
    // 俄罗斯www
    return 'https://elearning.hikvision.com/en/';
  }
  return 'https://elearning-tst.hikvision.com/en/';
};
function eLearningNoLogin(url) {
  Api.getELearnginSign()
    .then((res) => {
      const [, , data] = res;
      if (data.data?.sign) {
        let urlTemp = `${geteLearningUrl()}?sign=${encodeURIComponent(data.data.sign)}&appid=1`;
        window.open(urlTemp, '_blank');
      } else {
        window.open(url, '_blank');
      }
    })
    .catch(() => {
      window.open(url, '_blank');
    });
}

function getLocalUserInfo() {
  let userInfo = '';
  let data = localStorage.getItem(`${PREFIX.DEFAULT }data`) || '';
  if (data) {
    data = new Map(JSON.parse(data));
    if (data.has(`${PREFIX.DEFAULT }user`)) {
      userInfo = data.get(`${PREFIX.DEFAULT }user`).data;
    }
  }
  return userInfo;
}
function getLoginStatus() {
  return !!(
    document.cookie.replace(/(?:^|.*;\s*)hik_connect_pro_userlogin\s*=\s*([^;]*).*$|^.*$/, '$1') && getLocalUserInfo()
  );
}

const getFAQUrl = (index, languageIndex) => {
  const FAQUrl = 'http://enpinfodata.hikvision.com/analysisQR/showQR/7ac0a157.html';
  if (parseInt(languageIndex, 10) === 2) {
    return 'http://enpinfodata.hikvision.com/analysisQR/showQR/3ad0321b.html';
  }
  switch (parseInt(index, 10)) {
    case 23:
      return 'https://info.hikvision.com/hdp-faq';
    default:
      return FAQUrl;
  }
};

function getLinks() {
  const getTPPUrl = (index) => {
    const TPPUrl = 'https://tpp.hikvision.com';
    switch (parseInt(index, 10)) {
      case 23:
        return 'https://us.hikvision.com/en/partners/technology-partners';
      default:
        return TPPUrl;
    }
  };

  const getELearningUrl = (index) => {
    const eLearningUrl = 'https://elearning.hikvision.com/en';
    switch (parseInt(index, 10)) {
      case 54:
        return 'https://elearning.hikvision.com/br/';
      case 23:
        return 'https://www.hikvisionlearning.com';
      default:
        return eLearningUrl;
    }
  };

  const getYoutubeLink = (index) => {
    const youtubeLink = 'https://www.youtube.com/channel/UCfn2t5cHA0QawA7_OqlfFMw';
    switch (parseInt(index, 10)) {
      case 23:
        return 'https://www.youtube.com/@HikvisionUSAinc';
      default:
        return youtubeLink;
    }
  };

  const privacyPolicyUrl = `${window.location.origin}/#/statement/privacy`;
  const privacyServiceUrl = `${window.location.origin}/#/statement/service`;
  const officialUrl = COUNTRY_LINK_CODE.find((obj) => obj.areaId === countryOrRegionIndex)
    ? COUNTRY_LINK_CODE.find((obj) => obj.areaId === countryOrRegionIndex).url
    : 'https://www.hikvision.com/en/products/software/hik-proconnect/';
  /**
   * @description: 处理链接点击跳转
   * @param {Number} type 1：项目内路由跳转；2：跳转到外部链接；3：登录；4：注册；5：游客模式
   * @param {String} url type为1、2，地址
   * @param {Number} location 点击位置，用于区分埋点
   * @param {Number} buryType 埋点类型，用于统计页面底部点击埋点
   * @return {*}
   */
  let quick_links = [
    {
      label: 'Hikvision_Website',
      jumpType: 2,
      url: officialUrl,
      buryType: 2
    },
    {
      label: 'Technology_Partner_Portal',
      url: getTPPUrl(countryOrRegionIndex),
      jumpType: 2
    },
    {
      label: 'eLearning',
      url: getELearningUrl(countryOrRegionIndex),
      jumpType: 2,
      buryType: 4,
      isHide: countryOrRegionIndex === 106
    },
    {
      label: 'tourist_mode_enter',
      jumpType: 5,
      buryType: 3
    },
    {
      label: 'FAQ',
      jumpType: 2,
      url: getFAQUrl(countryOrRegionIndex, languageIndex),
      buryType: 8
    },
    {
      label: 'cookie_manager',
      jumpType: 2,
      url: '/manage-cookies/index.html'
    }
  ];
  return [
    {
      // 跳转链接列表
      title: 'quick_links',
      list: quick_links,
      show: true
    },
    {
      title: 'Policy',
      list: [
        {
          label: 'Privacy_Policy',
          jumpType: 2,
          url: privacyPolicyUrl,
          buryType: 5
        },
        {
          label: 'Terms_of_Use',
          jumpType: 2,
          url: privacyServiceUrl,
          buryType: 6
        }
      ],
      show: true
    },
    {
      title: 'Hik-ePartner_APP',
      list: [
        {
          label: 'ePartner_APP_text'
        },
        {
          qrCode: true
        }
      ],
      // US
      show: !(countryOrRegionIndex === 23)
    },
    {
      title: 'follow_us',
      list: [
        {
          jumpType: 2,
          url: getYoutubeLink(countryOrRegionIndex),
          icon: 'icon-youtubeLink',
          buryType: 9
        }
      ],
      show: true
    }
  ];
}
function initFooter() {
  // 是否展示快速链接  中性版不展示
  const oLink = document.querySelector('.footer-content .new-links');
  oLink
    && (oLink.style.display
      = getLoginStatus() || ['NEUTRAL', 'CUSTOMIZE', 'LTS'].includes(process.env.appmode) ? 'none' : 'flex');
  const hideLinks
    = {
      NEUTRAL: [
        '.icon-list-style',
        '.hikvision-website',
        '.technology-partner-portal',
        '.eLearning',
        '.faq',
        '.tourist-mode-enter',
        '.copyright-wrapper'
      ],
      CUSTOMIZE: [
        '.icon-list-style',
        '.hikvision-website',
        '.technology-partner-portal',
        '.eLearning',
        '.faq',
        '.tourist-mode-enter',
        '.copyright-wrapper'
      ],
      LTS: [
        '.icon-list-style',
        '.hikvision-website',
        '.technology-partner-portal',
        '.eLearning',
        '.faq',
        '.tourist-mode-enter',
        '.copyright-wrapper'
      ]
    }[process.env.appmode] || [];
  if (hideLinks.length) {
    const linkDoms = document.querySelectorAll(hideLinks.join(','));
    linkDoms?.forEach((dom) => {
      dom && (dom.style.display = 'none');
    });
  }

  // footer底部二维码图片
  const host = window.location.host;
  if (process.env.appmode !== 'NORMAL') {
    switch (process.env.appmode) {
      case 'LTS':
        document.getElementById('app-qrcode').src = require('@/natives/assets/img/lts_qrcode.webp');
        break;
      case 'NEUTRAL':
        document.getElementById('app-qrcode').src = require('@/natives/assets/img/neutral_qrcode.png.webp');
        break;
      default:
        document.getElementById('app-qrcode').src = require('@/natives/assets/img/www_qrcode.png.webp');
    }
  } else {
    switch (host) {
      case 'isa.hik-partner.com':
        document.getElementById('app-qrcode').src = require('@/natives/assets/img/isa_qrcode.png.webp');
        break;
      case 'ieu.hik-partner.com':
        document.getElementById('app-qrcode').src = require('@/natives/assets/img/ieu_qrcode.png.webp');
        break;
      case 'ius.hik-partner.com':
        document.getElementById('app-qrcode').src = require('@/natives/assets/img/ius_qrcode.png.webp');
        break;
      case 'www.hik-partnerru.com':
        document.getElementById('app-qrcode').src = require('@/natives/assets/img/ru_qrcode.png.webp');
        break;
      case 'isgp.hik-partner.com':
        document.getElementById('app-qrcode').src = require('@/natives/assets/img/isgp_qrcode.png.webp');
        break;
      case 'www.hik-partner.com':
      default:
        document.getElementById('app-qrcode').src = require('@/natives/assets/img/www_qrcode.png.webp');
    }
  }

  // newlinks
  const newLinkItems = document.querySelectorAll('.footer-content .new-links .item-style');
  const newLinks = [
    {
      title: 'device_compatibility_list',
      link: 'compatibilityonline',
      type: 'dynamic'
    },
    {
      title: 'user_manual',
      link: 'http://enpinfodata.hikvision.com/analysisQR/showQR/3f1d2206.html',
      type: 'static'
    },
    {
      title: 'data_sheet',
      link: 'http://enpinfodata.hikvision.com/analysisQR/showQR/4c2e6c31.html',
      type: 'static'
    },
    {
      title: 'whats_new',
      link: `http://enpinfodata.hikvision.com/analysisQR/showQR/0f7130fc.html`,
      type: 'static'
    }
  ];

  newLinkItems.forEach((item, index) => {
    item.addEventListener('click', function () {
      switch (newLinks[index].title) {
        case 'device_compatibility_list':
          bury.bottomIconLink(1);
          break;
        case 'user_manual':
          bury.bottomIconLink(2);
          break;
        case 'data_sheet':
          bury.bottomIconLink(3);
          break;
        case 'whats_new':
          bury.bottomIconLink(4);
          break;
        default:
          console.log('FooterIconLink埋点失败');
      }
      if (newLinks[index].type === 'static') {
        window.open(newLinks[index].link);
      } else {
        window.open(`${window.location.origin }/#/${ newLinks[index].link}`);
      }
    });
  });

  // 链接列表渲染内容
  const ListLinks = getLinks();
  document.querySelectorAll('.footer-content .links').forEach((linkItem, idx) => {
    linkItem.querySelectorAll('button.link-btn,#follow-us-youtube').forEach((linkBtn, $idx) => {
      const linkObj = ListLinks[idx].list[$idx];
      if (linkObj.isHide) {
        linkBtn.style.display = 'none';
        return;
      }
      linkBtn.addEventListener('click', function () {
        if (linkObj.buryType) {
          bury.bottomWordLink(linkObj.buryType);
        }
        switch (linkObj.jumpType) {
          case 2:
            if (linkObj.url) {
              if (linkObj.label === 'FAQ') {
                linkObj.url = getFAQUrl(countryOrRegionIndex, languageIndex);
              }
              if (
                linkObj.url.includes('elearning.hikvision.com')
                && getLoginStatus()
                && getLocalUserInfo()
                && getLocalUserInfo().hikId
              ) {
                eLearningNoLogin(linkObj.url);
              } else {
                window.open(linkObj.url, '_blank');
              }
            }
            break;
          case 5:
            window.location.href = `${window.location.origin}/#/EP2FuncPage?EP2ToHPCTourist=true`;
            break;
          default:
            break;
        }
      });
    });
  });
}

initFooter();
